import { Injectable } from '@angular/core';
import { ToastController, LoadingController, Platform } from 'ionic-angular';

import { Storage } from '@ionic/storage';

@Injectable()
export class Tools {
  constructor(
    private toastCtrl: ToastController,
    private nativeStorage: Storage,
    public loadingCtrl: LoadingController,
    public platform: Platform
  ){}

  tratCallback(res:any){
    if(res){
      return {status:true,data:res}
    }else{
      return {status:false,msg:'Não encontrado'}
    }
  }

  showAlert(tipo:any,msg:any,callback?:any){
    if(tipo=='toast'){
      let toast = this.toastCtrl.create({
        message: msg,
        duration: 3000,
        position: 'top'
      });
      toast.present();
    }
    if(tipo=='alert'){
      alert(msg);
    }
  }

  showLoading(msg:any){
    return this.loadingCtrl.create({content:msg})
  }

  storage(tipo:any,key:any,value:any,callback:any){
    if(tipo=='save'||tipo=='set'){
      this.nativeStorage.set(key,value);
      callback({status:true})
    }
    else if(tipo=='load'||tipo=='get'){
      this.nativeStorage.get(key).then((res)=>callback(this.tratCallback(res)));
    }
    else if(tipo=='del'||tipo=='remove'){
      this.nativeStorage.remove(key);
      callback({status:true})
    }
  }
}



// WEBPACK FOOTER //
// ./src/providers/tools/tools.ts